module.exports = __webpack_public_path__ + "img/investor_LancerCapital@2x.55a98179.png";